import moment from "moment";

export const formatDate = (value: any, format = "DD/MM/YYYY hh:mm a") => {
  return moment(value).add(moment().utcOffset(), "m").format(format);
};
